/* eslint-disable @typescript-eslint/no-unused-vars */
import Header from "../../../components/common/layout/Header";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { useSitemap } from "../../../shared/hooks/use-sitemap";
import Canonical from "../../../components/common/layout/Canonical";
import { NCMCInfo } from "../../../components/common/svg/AllSvg";
import SecondaryBtn from "../../../components/common/form/SecondaryBtn";

const NCMC = () => {
    const { t } = useTranslation('common');
    useSitemap();

    const cardStationData: any[] = [
        {
            "station": "Aarey JVLR",
            "entry_exit_gate": "A1/B1",
            "landmark_details": "Powai"
        },
        {
            "station": "Marol Naka",
            "entry_exit_gate": "B1",
            "landmark_details": "Exit near Pearl Academy"
        },
        {
            "station": "Santacruz Metro",
            "entry_exit_gate": "B2",
            "landmark_details": "Sen Nagar Side"
        },
        {
            "station": "Bandra-Kurla Complex",
            "entry_exit_gate": "A1",
            "landmark_details": "Near NSE"
        },
        {
            "station": "Dadar Metro",
            "entry_exit_gate": "A2",
            "landmark_details": "Near TVM"
        },
        {
            "station": "Siddhivinayak",
            "entry_exit_gate": "A1, A2, A3",
            "landmark_details": "Prabhadevi Side Exit"
        },
    ];

    const sbiBranchesData: any[] = [
        {
            "sr_no": 1,
            "module": "AO SOUTH MUMBAI",
            "region": "Fort",
            "branch_name": "Cuffe Parade",
            "branch_code": "5345",
            "station_name": "Cuffe Parade",
            "location_address": "Captain Prakash Pethe Marg, Colaba Woods garden, Cuffe Parade, Mumbai-400005"
        },
        {
            "sr_no": 2,
            "module": "AO SOUTH MUMBAI",
            "region": "Fort",
            "branch_name": "Madame Cama Road branch",
            "branch_code": "8586",
            "station_name": "Vidhan Bhavan",
            "location_address": "Vidhan Chowk, Free Press Journal Marg,Opposite Mittal Towers, Nariman Point, Mumbai-400021"
        },
        {
            "sr_no": 3,
            "module": "AO SOUTH MUMBAI",
            "region": "Fort",
            "branch_name": "Churchgate",
            "branch_code": "1821",
            "station_name": "Churchgate Metro",
            "location_address": "Senapati Tata Road,Near Eros Cinema Theatre, Churchgate, Mumbai-400020"
        },
        {
            "sr_no": 4,
            "module": "AO SOUTH MUMBAI",
            "region": "Fort",
            "branch_name": "M G Road Fort",
            "branch_code": "20634",
            "station_name": "Hutatma Chowk",
            "location_address": "Hutatma Chowk, Dr.Dadabhai Naoroji Road, Fort, Mumbai-400001"
        },
        {
            "sr_no": 5,
            "module": "Mumbai Main branch",
            "region": "#N/A",
            "branch_name": "Mumbai Main branch",
            "branch_code": "3000",
            "station_name": "CST Metro",
            "location_address": "CSMT Metro Station, Azad Maidan, Mumbai-400001"
        },
        {
            "sr_no": 6,
            "module": "AO SOUTH MUMBAI",
            "region": "AO SOUTH MUMBAI",
            "branch_name": "GIRGAON",
            "branch_code": "374",
            "station_name": "Kalbadevi Metro",
            "location_address": "Jagannath Shankar Sheth Rd, Near NB Velkar Street,Mumbai-400002"
        },
        {
            "sr_no": 7,
            "module": "AO SOUTH MUMBAI",
            "region": "AO SOUTH MUMBAI",
            "branch_name": "GIRGAON",
            "branch_code": "374",
            "station_name": "Girgaon Metro",
            "location_address": "Thakurdwar road junction, Jagannath Shankar Seth Road, Mumbai-400004"
        },
        {
            "sr_no": 8,
            "module": "AO SOUTH MUMBAI",
            "region": "Fort",
            "branch_name": "GRANT ROAD EAST",
            "branch_code": "61525",
            "station_name": "Grand Road Metro",
            "location_address": "Near Fire Brigade - Lamington Road, Bharat Nagar, Grant Road East, Mumbai-400007"
        },
        {
            "sr_no": 9,
            "module": "AO SOUTH MUMBAI",
            "region": "Fort",
            "branch_name": "Mumbai Central",
            "branch_code": "547",
            "station_name": "Mumbai Central Metro",
            "location_address": "Dr. Anandrao Nair Marg, Mumbai Central Railway Station, Mumbai-400008"
        },
        {
            "sr_no": 10,
            "module": "AO SOUTH MUMBAI",
            "region": "Fort",
            "branch_name": "JACOB CIRCLE",
            "branch_code": "1835",
            "station_name": "Mahalaxmi Metro",
            "location_address": "Near Sant Gadge Maharaj Udhyan, Arthur Rd, RTO Colony, Agripada, Mumbai-400011"
        },
        {
            "sr_no": 11,
            "module": "AO WEST MUMBAI",
            "region": "Worli",
            "branch_name": "Shivsagar Estate",
            "branch_code": "1154",
            "station_name": "Science Museum",
            "location_address": "Dr Elijah Moses Rd, Near Nehru Science Center, Worli, Mumbai-400018"
        },
        {
            "sr_no": 12,
            "module": "AO WEST MUMBAI",
            "region": "Worli",
            "branch_name": "Shivsagar Estate",
            "branch_code": "1154",
            "station_name": "Acharya Atre Chowk",
            "location_address": "Dr Elijah Moses Rd, Acharya Atre Chowk, Worli Naka, Shivaji Nagar, Worli, Mumbai-400018"
        },
        {
            "sr_no": 13,
            "module": "AO WEST MUMBAI",
            "region": "Worli",
            "branch_name": "Worli North",
            "branch_code": "290",
            "station_name": "Worli",
            "location_address": "Dr. Annie Besant Road, Worli Shivaji Nagar, Opposite Glaxo, Worli, Mumbai-400030"
        },
        {
            "sr_no": 14,
            "module": "AO WEST MUMBAI",
            "region": "Worli",
            "branch_name": "Veer Savarkar Marg",
            "branch_code": "5355",
            "station_name": "Siddhi Vinayak",
            "location_address": "Near Siddhivinayak Temple, Below Sane Guruji Marg, Veer Savarkar Tank, S.V.S. Road, Prabhadevi, Mumbai-400028"
        },
        {
            "sr_no": 15,
            "module": "AO SOUTH MUMBAI",
            "region": "Sion",
            "branch_name": "Dadar West",
            "branch_code": "20377",
            "station_name": "Dadar Metro",
            "location_address": "Near Kabutar Khana, Ram Ganesh Gadkari Chowk, Dadar West, Mumbai-400028"
        },
        {
            "sr_no": 16,
            "module": "AO WEST MUMBAI",
            "region": "Worli",
            "branch_name": "Mahim Branch",
            "branch_code": "3837",
            "station_name": "Sheetal Devi Temple",
            "location_address": "Near Sheetala Devi Mandir, Lady Jamshedji Road, Mahim, Mumbai-400016"
        },
        {
            "sr_no": 17,
            "module": "AO WEST MUMBAI",
            "region": "Sion",
            "branch_name": "Dharavi Branch",
            "branch_code": "3601",
            "station_name": "Dharavi Metro",
            "location_address": "Junction : Sion Link Road, Near Dharavi T Junction, Dharavi,Mumbai-400017"
        },
        {
            "sr_no": 18,
            "module": "BKC Branch",
            "region": "BKC Branch",
            "branch_name": "BKC Branch",
            "branch_code": "4380",
            "station_name": "Bandra(BKC) Metro",
            "location_address": "G-1 Bharat Diamond Bourse Complex, Bandra East, Mumbai-400051"
        },
        {
            "sr_no": 19,
            "module": "AO WEST MUMBAI",
            "region": "Worli",
            "branch_name": "Govt Colony",
            "branch_code": 3838,
            "station_name": "Vidhanagari",
            "location_address": "Near All India Institute of Local Self Government, F Block TPS Road behind Government Colony, Bandra East, Mumbai-400051"
        },
        {
            "sr_no": 20,
            "module": "AO WEST MUMBAI",
            "region": "Worli",
            "branch_name": "Santacruz East",
            "branch_code": 13265,
            "station_name": "Santacruz Metro",
            "location_address": "Below Western Express Highway, Davri Nagar, Vakola Junction, Santacruz East, Mumbai-400055"
        },
        {
            "sr_no": 21,
            "module": "AO WEST MUMBAI",
            "region": "Worli",
            "branch_name": "Vile Parle East",
            "branch_code": 1174,
            "station_name": "Domestic Airport",
            "location_address": "Domestic Airport Road, Navpada, Vile Parle, Mumbai-400099"
        },
        {
            "sr_no": 22,
            "module": "AO WEST MUMBAI",
            "region": "Worli",
            "branch_name": "Vile Parle East",
            "branch_code": 1174,
            "station_name": "Sahar Road",
            "location_address": "A/1 Colony, J B Nagar, Andheri East, Mumbai-400099"
        },
        {
            "sr_no": 23,
            "module": "AO WEST MUMBAI",
            "region": "Worli",
            "branch_name": "Vile Parle East",
            "branch_code": 1174,
            "station_name": "International Airport",
            "location_address": "Chhatrapati Shivaji Maharaj International Airport Road, Navpada, Vile Parle East, Mumbai-400099"
        },
        {
            "sr_no": 24,
            "module": "AO WEST MUMBAI",
            "region": "Worli",
            "branch_name": "Marol Naka",
            "branch_code": 1594,
            "station_name": "Marol Naka",
            "location_address": "Marol Naka, Near Marol Fire Brigade, Marol, Andheri East, Mumbai-400059"
        },
        {
            "sr_no": 25,
            "module": "AO WEST MUMBAI",
            "region": "Worli",
            "branch_name": "MIDC Andheri",
            "branch_code": 7074,
            "station_name": "MIDC",
            "location_address": "Road No. 7, Near ESIC office, MIDC, Andheri (East), Mumbai-400093"
        },
        {
            "sr_no": 26,
            "module": "AO WEST MUMBAI",
            "region": "Worli",
            "branch_name": "SEZ Branch",
            "branch_code": 11690,
            "station_name": "Seepz Metro",
            "location_address": "SEEPZ Gate No.1, Opp SEEPZ Bus Depot, Krantiveer Lakhaji Salve Marg, SEEPZ, Andheri East, Mumbai-400093"
        },
        {
            "sr_no": 27,
            "module": "AO WEST MUMBAI",
            "region": "Andheri",
            "branch_name": "Goregaon East",
            "branch_code": 1975,
            "station_name": "Aarey",
            "location_address": "Beside Adani Electricity Management Institute, Ganesh Nagar, Goregaon, Mumbai-400065"
        }
    ];

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.ncmc.title")}</title>
                <meta name="description" content={t("seo_friendly.ncmc.desc")} />
            </Helmet>
            <div className="w-full h-full relative bg-white dark:bg-bgDarkDull">
                <div className="w-full relative h-full">
                    <div className="ncmc-bg absolute top-0 left-0 w-[40%] h-[55vh]"></div>
                    <img src={require('../../../assets/images/pattern4.png')} alt="pattern" className="absolute bottom-0 left-0 flex items-start justify-start h-full" />
                    <div className="relative z-[1]">
                        <Header type="passenger" />

                        <div className="flex items-center justify-between  gap-[30px] xlx:gap-[50px] w-full container pt-[50px] xlx:pt-[60px] xl:!max-w-[1150px] lg:flex-row flex-col">
                            <div className="flex flex-col gap-[30px] lg:gap-[40px] lgs:min-w-[378px] lg:pb-[40px] xlx:pb-[60px]">
                                <div className="flex flex-col gap-[15px]">
                                    <h1 className="text-primaryText dark:text-white font-bold">Tap. Ride. Go.</h1>
                                    <h4 className="text-primary font-bold max-w-[378px]">With NCMC on Mumbai Metro Line 3, your journey just got smarter!</h4>
                                </div>

                                {/* <SecondaryBtn title="Recharge your card" css="w-fit px-[24px] flex items-center justify-center !rounded-[6px] !text-base uppercase font-bold" /> */}
                            </div>

                            <img src={require('../../../assets/images/card.png')} alt="card" />
                        </div>

                        <div className="bg-[#F6F9FC] dark:bg-[#0B121A] py-[30px] lg:py-[38px] w-full">
                            <div className="container xl:!max-w-[1150px] flex lg:items-center justify-between w-full gap-[20px] lg:gap-[15px] lg:flex-row flex-col">
                                <div className="flex flex-col gap-[8px]">
                                    <h3 className="text-blackDull dark:text-textBlackDull font-bold">Get your NCMC card at these Stations</h3>
                                    <div className="flex gap-[6px]">
                                        <NCMCInfo />
                                        <p className="text-blackDull dark:text-textBlackDull text-opacity-[0.7] dark:text-opacity-[0.7] font-medium">For more detail please refer the below table.</p>
                                    </div>
                                </div>

                                <div className="flex items-center flex-wrap gap-[9px] lg:max-w-[482px]">
                                    <div className="border-2 rounded-[8px] xlx:rounded-[12px] flex items-center h-[30px] justify-center px-[12px] xlx:px-[15px] text-sm !leading-tight font-semibold text-secPurple border-secPurple">Aarey JVLR</div>
                                    <div className="border-2 rounded-[8px] xlx:rounded-[12px] flex items-center h-[30px] justify-center px-[12px] xlx:px-[15px] text-sm !leading-tight font-semibold text-secRed border-secRed">Marol Naka</div>
                                    <div className="border-2 rounded-[8px] xlx:rounded-[12px] flex items-center h-[30px] justify-center px-[12px] xlx:px-[15px] text-sm !leading-tight font-semibold text-secOrange border-secOrange">Santacruz Metro</div>
                                    <div className="border-2 rounded-[8px] xlx:rounded-[12px] flex items-center h-[30px] justify-center px-[12px] xlx:px-[15px] text-sm !leading-tight font-semibold text-[#B497E7] border-[#B497E7]">Bandra-Kurla Complex</div>
                                    <div className="border-2 rounded-[8px] xlx:rounded-[12px] flex items-center h-[30px] justify-center px-[12px] xlx:px-[15px] text-sm !leading-tight font-semibold text-secBlue2 border-secBlue2">Dadar Metro</div>
                                    <div className="border-2 rounded-[8px] xlx:rounded-[12px] flex items-center h-[30px] justify-center px-[12px] xlx:px-[15px] text-sm !leading-tight font-semibold text-secGreen border-secGreen">Siddhivinayak</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="w-full h-full container py-[30px] xs:py-[40px] xlx:py-[60px] flex flex-col gap-[40px] lg:gap-[50px] xlx:gap-[60px]" id="home">
                    <div className="flex flex-col gap-[20px] xs:gap-[30px] w-full items-center justify-center">
                        <h2 className="text-primary font-bold">Quick Glance at NCMC</h2>

                        <div className="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-4 gap-[15px] xs:gap-[20px] items-start w-full justify-between">
                            <div className="flex flex-col gap-[30px] w-full items-center justify-center">
                                <img src={require('../../../assets/images/contactless-entry.png')} alt="Contactless Entry at All Stations" className="w-[138px]" />
                                <div className="flex flex-col items-center justify-center">
                                    <h4 className="text-blackDark dark:text-textBlackDark font-bold max-w-[142px] text-center">Contactless Entry at All Stations</h4>
                                    <h6 className="max-w-[205px] text-blackDull dark:text-textBlackDull text-opacity-[0.7] dark:text-opacity-[0.7] font-medium text-center pt-[6px]">The NCMC Card enables contactless entry at all</h6>
                                    <h6 className="text-blackDull dark:text-textBlackDull text-opacity-[0.7] dark:text-opacity-[0.7] font-extrabold text-center pt-[2px]">MML-3 stations</h6>
                                </div>
                            </div>

                            <div className="flex flex-col gap-[30px] w-full items-center justify-center">
                                <img src={require('../../../assets/images/one-card.png')} alt="One Card for All Metro Lines" className="w-[138px]" />
                                <div className="flex flex-col items-center justify-center">
                                    <h4 className="text-blackDark dark:text-textBlackDark font-bold max-w-[190px] text-center">One Card for All Metro Lines</h4>
                                    <h6 className="max-w-[248px] text-blackDull dark:text-textBlackDull text-opacity-[0.7] dark:text-opacity-[0.7] font-medium text-center pt-[6px]">The same card can also be used across</h6>
                                    <h6 className="text-blackDull dark:text-textBlackDull text-opacity-[0.7] dark:text-opacity-[0.7] font-extrabold text-center pt-[2px]">Mumbai Metro Line 3, 2A & 7</h6>
                                </div>
                            </div>

                            <div className="flex flex-col gap-[30px] w-full items-center justify-center">
                                <img src={require('../../../assets/images/ride-easy.png')} alt="Ride Easy with NCMC at MML-3" className="w-[138px]" />
                                <div className="flex flex-col items-center justify-center">
                                    <h4 className="text-blackDark dark:text-textBlackDark font-bold max-w-[173px] text-center">Ride Easy with NCMC at MML-3</h4>
                                    <h6 className="max-w-[272px] text-blackDull dark:text-textBlackDull text-opacity-[0.7] dark:text-opacity-[0.7] font-medium text-center pt-[6px]">NCMC cards issued by Mumbai Metro Line 1, 2A & 7, and other transport operators are also compatible and rechargeable at MML - 3 stations.</h6>
                                </div>
                            </div>

                             <div className="flex flex-col gap-[30px] w-full items-center justify-center">
                                <img src={require('../../../assets/images/key-best-public.png')} alt="Key To Best Public Transport" className="w-[138px]" />
                                <div className="flex flex-col items-center justify-center">
                                    <h4 className="text-blackDark dark:text-textBlackDark font-bold max-w-[228px] text-center">Key To Best Public Transport Anywhere you go.</h4>
                                    <h6 className="max-w-[261px] text-blackDull dark:text-textBlackDull text-opacity-[0.7] dark:text-opacity-[0.7] font-medium text-center pt-[6px]">Single card across multiple transit systems, including other Mumbai Metro lines, buses, and metro networks in other cities.</h6>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col gap-[20px]">
                        <h3 className="text-blackDull dark:text-textBlackDull font-bold">Get your NCMC card at these Stations :</h3>
                        <div className="table-data">
                            <div className="section">
                                <div className="subsection">
                                    <div className="section-content">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th className="tbl-heading">Station</th>
                                                    <th className="tbl-heading-center">Entry/Exit Gate</th>
                                                    <th className="tbl-heading">Landmark Details</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array?.isArray(cardStationData) && cardStationData?.map((item: any, index: number) => (
                                                    <tr key={index}>
                                                        <td className="tbl-row !font-semibold">{item?.station}</td>
                                                        <td className="tbl-row !font-extrabold">{item?.entry_exit_gate}</td>
                                                        <td className="tbl-row !font-semibold">{item?.landmark_details}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="flex flex-col gap-[20px]">
                        <h3 className="text-blackDull dark:text-textBlackDull font-bold">Get your NCMC card from these SBI Branches :</h3>
                        <div className="table-data">
                            <div className="section">
                                <div className="subsection">
                                    <div className="section-content">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th className="tbl-heading">Sr. No.</th>
                                                    <th className="tbl-heading-center">Module</th>
                                                    <th className="tbl-heading">Region</th>
                                                    <th className="tbl-heading">Branch Name</th>
                                                    <th className="tbl-heading">Branch Code</th>
                                                    <th className="tbl-heading">Station Name</th>
                                                    <th className="tbl-heading">Location Address</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array?.isArray(sbiBranchesData) && sbiBranchesData?.map((item: any, index: number) => (
                                                    <tr key={index}>
                                                        <td className="tbl-row !font-semibold">{item?.sr_no}</td>
                                                        <td className="tbl-row !font-semibold">{item?.module}</td>
                                                        <td className="tbl-row !font-semibold">{item?.region}</td>
                                                        <td className="tbl-row !font-semibold">{item?.branch_name}</td>
                                                        <td className="tbl-row !font-semibold">{item?.branch_code}</td>
                                                        <td className="tbl-row !font-semibold">{item?.station_name}</td>
                                                        <td className="tbl-row !font-semibold max-w-[250px]">{item?.location_address}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    );
};

export default NCMC;